import is from 'date-fns/locale/is'

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import {
  LocalizationProvider,
  LocalizationProviderProps,
  isIS,
} from '@mui/x-date-pickers'

export type DateFnsProviderProps = Omit<
  LocalizationProviderProps,
  'dateAdapter'
> & {
  dateAdapter?: LocalizationProviderProps['dateAdapter']
}

export const DateFnsProvider = ({
  children,
  ...props
}: DateFnsProviderProps) => {
  const { dateAdapter, ...localizationProps } = props
  return (
    <LocalizationProvider
      dateAdapter={dateAdapter || AdapterDateFns}
      adapterLocale={is}
      localeText={
        isIS.components.MuiLocalizationProvider.defaultProps.localeText
      }
      {...localizationProps}
    >
      {children}
    </LocalizationProvider>
  )
}

export default DateFnsProvider
